export function getFormDataFromObject(obj) {
    const formData = new FormData();

    for (let prop in obj) {
        if (Array.isArray(obj[prop])) {
            obj[prop].forEach((item, index) => {
                formData.append(`${prop}`, item);
            });
        } else {
            formData.append(prop, obj[prop]);
        }
    }

    return formData;
}